import { render } from "./KakaoPostcode.vue?vue&type=template&id=6b575ca2&scoped=true"
import script from "./KakaoPostcode.vue?vue&type=script&lang=js"
export * from "./KakaoPostcode.vue?vue&type=script&lang=js"

import "./KakaoPostcode.vue?vue&type=style&index=0&id=6b575ca2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b575ca2"]])

export default __exports__